import React, { Component } from 'react';
import { Grid, Divider } from '@material-ui/core';
import EditIcon from '@material-ui/icons/Edit';
import IconButton from '@material-ui/core/IconButton';
import PropTypes from 'prop-types';
import StringItemSelector from './StringItemSelector';
import EditAttributeModal from './EditAttributeModal';
import RequireScope from '../RequireScope';
import { fetchPositionsAll, updateAttribute } from '../../helpers/externalRequests';
import i18n from '../../i18n';

class AttributeEditor extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showModal: false,
      selectedPositionIndex: -1,
      positionOptions: [],
    };
  }

  componentDidMount = () => {
    this.getPositions();
  };

  buildPositionOptions = () => {
    const { allPositionsData } = this.state;

    const positionOptions = [];
    Object.keys(allPositionsData || []).forEach(index => {
      const positionOption = {
        id: index,
        label: i18n.t(`positions:${allPositionsData[index].positionName}`),
        value: index,
        isActive: allPositionsData[index].isActive,
      };
      positionOptions.push(positionOption);
    });

    this.setState({ positionOptions });
  };

  editAttribute = async (id, positionName, editedAttribute, oldAttributes) => {
    const { openSnackbar } = this.props;
    try {
      await updateAttribute(id, positionName, editedAttribute, oldAttributes)
      this.getPositions();
      openSnackbar(i18n.t('setting:editAttributeSuccess'));
    } catch {
      openSnackbar(i18n.t('setting:editAttributeError'));
    };
  };

  getPositions = async () => {
    const allPositionsData = await fetchPositionsAll();
    this.setState({ allPositionsData: allPositionsData.data });
    this.buildPositionOptions();
  };

  showModal = () => {
    this.setState({ showModal: true });
  };

  hideModal = () => {
    this.setState({ showModal: false });
  };

  onPositionChange = event => {
    const selectedIndex = event.target.value;
    this.setState({
      selectedPositionIndex: selectedIndex,
    });
  };

  render() {
    const {
      allPositionsData,
      positionOptions,
      showModal,
      selectedPositionIndex,
    } = this.state;

    return (
      <Grid container>
        <Grid item xs={7}>
          <h6>{i18n.t('setting:manageAttributes')}</h6>
          <Divider />
          <br />
          <StringItemSelector
            selectedItem={selectedPositionIndex}
            items={positionOptions.filter(position => position.isActive)}
            onItemChange={this.onPositionChange}
            label={i18n.t('setting:warningAttributeModal')}
            helperText={i18n.t('setting:attributeHelp')}
          />
          <RequireScope scopes={['entities:write']}>
            <IconButton
              aria-label="edit"
              color="secondary"
              onClick={this.showModal}
            >
              <EditIcon />
            </IconButton>
          </RequireScope>
          {showModal && (
            <EditAttributeModal
              showModal={showModal}
              hideModal={this.hideModal}
              positionAttributeData={
                selectedPositionIndex > -1
                  ? allPositionsData[selectedPositionIndex]
                  : {}
              }
              selectedValidPosition={selectedPositionIndex}
              editLocation={this.editLocation}
              editAttribute={this.editAttribute}
            />
          )}
        </Grid>
      </Grid>
    );
  }
}

AttributeEditor.propTypes = {
  openSnackbar: PropTypes.func.isRequired,
}

export default AttributeEditor;
